/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const login = $( '.login-wrap' );

      if ( login.length > 0 ) { // Check if login wrap exists and has elements
        // Check if each element exists before animating
        const formContainer = $( '.login-form-container' );
        const loginTitle = $( '.login-title' );
        const loginSubtitle = $( '.login-subtitle' );
        const inputContainer = $( '.login-input-container' );
        const submit = $( '.submit' );
        const footer = $( '.login-footer' );

        if ( formContainer.length ) gsap.set( formContainer, {autoAlpha: 0, y: 50} );
        if ( loginTitle.length ) gsap.set( loginTitle, {autoAlpha: 0, y: 20} );
        if ( loginSubtitle.length ) gsap.set( loginSubtitle, {autoAlpha: 0, y: 20} );
        if ( inputContainer.length ) gsap.set( inputContainer, {autoAlpha: 0, y: 20} );
        if ( submit.length ) gsap.set( submit, {autoAlpha: 0, y: 20} );
        if ( footer.length ) gsap.set( footer, {autoAlpha: 0, y: 20} );

        const tl = gsap.timeline( {defaults: {ease: 'power3.out'}} );

        // Only add animations for elements that exist
        if ( formContainer.length ) {
          tl.to( formContainer, {duration: 0.8, autoAlpha: 1, y: 0} );
        }
        if ( loginTitle.length ) {
          tl.to( loginTitle, {duration: 0.5, autoAlpha: 1, y: 0} );
        }
        if ( loginSubtitle.length ) {
          tl.to( loginSubtitle, {duration: 0.5, autoAlpha: 1, y: 0}, '-=0.3' );
        }
        if ( inputContainer.length ) {
          tl.to( inputContainer, {duration: 0.5, autoAlpha: 1, y: 0, stagger: 0.2}, '-=0.3' );
        }
        if ( submit.length ) {
          tl.to( submit, {duration: 0.5, autoAlpha: 1, y: 0}, '-=0.3' );
        }
        if ( footer.length ) {
          tl.to( footer, {duration: 0.5, autoAlpha: 1, y: 0}, '-=0.3' );
        }
      }

      $( document ).on( 'click', '.popup-link', function( event ) {
        if ( event.target.classList.contains( 'processing' ) ) {
          event.preventDefault();
          return;
        }

        event.target.classList.add( 'processing' );
        localStorage.clear();
        sessionStorage.clear();
      } );
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.popup-trigger' ).magnificPopup( {
        type: 'inline',
        closeBtnInside: true,
        showCloseBtn: true,
        removalDelay: 300,
        mainClass: 'mfp-fade',
      } );

      // Close button functionality inside the popup
      $( document ).on( 'click', '.popup-close', function( e ) {
        e.preventDefault();
        $.magnificPopup.close();
      } );


      // $( document ).ready( function() {
      //   const digits = document.querySelectorAll( '.digit' );
      //   const timeline = gsap.timeline( {defaults: {duration: 2, ease: 'bounce.out'}} );

      //   digits.forEach( ( digit, index ) => {
      //     const randomX = Math.random() * -5000;
      //     const randomY = Math.random() * -500;
      //     timeline.fromTo( digit,
      //         {
      //           x: randomX,
      //           y: randomY,
      //           rotation: 720,
      //           opacity: 0,
      //         },
      //         {
      //           x: 0,
      //           y: 0,
      //           rotation: 0,
      //           stagger: 0.3 * index,
      //           opacity: 1,
      //         }, '<0.5' );
      //   } );
      //   const textElements = document.querySelectorAll( '.error-title, .error-message' );

      //   textElements.forEach( ( element ) => {
      //     gsap.to( element, {
      //       y: 10,
      //       repeat: -1, // Infinite repeat
      //       yoyo: true, // Reverse the animation on alternate cycles
      //       duration: 1, // Duration of each cycle
      //       ease: 'sine.inOut', // Easing for smooth movement
      //     } );
      //   } );

      //   gsap.fromTo(
      //       '.circle',
      //       {opacity: 0, scale: 0},
      //       {opacity: 1, scale: 1, y: -20, stagger: 0.3, repeat: -1, yoyo: true},
      //   );
      // } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
